import { StandardPartOfferResponseDTO } from '@luminovo/api-contracts';

export function extractTotalOnOrderQuantity({ offer }: { offer: StandardPartOfferResponseDTO }): number {
    return offer.availability.on_order.reduce((sum, onOrder) => sum + onOrder.quantity, 0);
}
